export const Minus = ({ className }: { className?: string }) => (
  <svg
    className={className}
    width="17"
    height="17"
    viewBox="0 0 17 17"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.5 7.49805C14.0523 7.49805 14.5 7.94576 14.5 8.49805C14.5 9.05033 14.0523 9.49805 13.5 9.49805L3.5 9.49805C2.94771 9.49805 2.5 9.05033 2.5 8.49805C2.5 7.94576 2.94772 7.49805 3.5 7.49805L13.5 7.49805Z"
      fill="currentColor"
    />
  </svg>
);
